import { render, staticRenderFns } from "./ArchiveContact.vue?vue&type=template&id=7b3200b1&"
import script from "./ArchiveContact.vue?vue&type=script&lang=js&"
export * from "./ArchiveContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports